/** Checks if key is in object */
var keyInObject = function keyInObject(obj, prop) {
  return typeof obj === "object" && prop in obj;
};
/** Checks if object is an error */


var isError = function isError(obj) {
  return keyInObject(obj, "name") && keyInObject(obj, "message");
};
/** Gets message of error */


var getErrorMessage = function getErrorMessage(err) {
  return isError(err) ? err.message : undefined;
};
/** Logs an item */


var logPassThrough = function logPassThrough(logItem) {
  console.log(logItem);
  return logItem;
};
/** Returns classname string */


var getClassName = function getClassName(className, condition) {
  return condition ? className : "";
};

export { getClassName, getErrorMessage, isError, keyInObject, logPassThrough };